// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let IsNewQueryParam = require("./IsNewQueryParam.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let MarketingProfileMemberPhotoForm = require("./MarketingProfileMemberPhotoForm.bs.js");
let EditMarketingProfileMemberInfoForm = require("./EditMarketingProfileMemberInfoForm.bs.js");
let EditMarketingProfileMemberQuery_graphql = require("../../__generated__/EditMarketingProfileMemberQuery_graphql.bs.js");
let EditMarketingProfileMemberSocialAccountsForm = require("./EditMarketingProfileMemberSocialAccountsForm.bs.js");
let EditMarketingProfileMember_page_marketingProfileMember_graphql = require("../../__generated__/EditMarketingProfileMember_page_marketingProfileMember_graphql.bs.js");
let EditMarketingProfileMember_header_marketingProfileMember_graphql = require("../../__generated__/EditMarketingProfileMember_header_marketingProfileMember_graphql.bs.js");

let convertFragment = EditMarketingProfileMember_header_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function EditMarketingProfileMember$Header(props) {
  let member = RescriptRelay_Fragment.useFragment(EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment, props.member);
  let match = IsNewQueryParam.use();
  let breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: "Members",
      href: `/account/team_marketing_profile/members?is_new=` + (
        match[0] ? "1" : "0"
      )
    },
    {
      name: member.displayName,
      href: `/account/team_marketing_profile/members/` + member.id + `/edit`
    }
  ];
  let name = Stdlib_Option.getOr(member.firstName, member.displayName);
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: `Edit ` + name + `'s profile`,
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  Fragment: Fragment,
  make: EditMarketingProfileMember$Header
};

let convertFragment$1 = EditMarketingProfileMember_page_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function EditMarketingProfileMember$Page(props) {
  let member = RescriptRelay_Fragment.useFragment(EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1, props.member);
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(EditMarketingProfileMember$Header, {
          member: member.fragmentRefs
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h3", {
                  children: "Member information",
                  className: "text-lg font-semibold leading-7 text-gray-900 sm:gap-4 sm:py-6"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(EditMarketingProfileMemberInfoForm.make, {
                    member: member.fragmentRefs
                  }),
                  className: "pt-4 sm:pt-0"
                })
              ],
              className: "pb-12 space-y-4 sm:space-y-0 divide-y divide-zinc-200 sm:pb-0"
            }),
            ReactRender.ifTrue(JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("h3", {
                      children: "Profile picture",
                      className: "text-lg font-semibold leading-7 text-gray-900 sm:gap-4 sm:py-6"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(MarketingProfileMemberPhotoForm.make, {
                        member: member.fragmentRefs
                      }),
                      className: "pt-4 sm:pt-0"
                    })
                  ],
                  className: "pb-12 space-y-4 sm:space-y-0 divide-y divide-zinc-200 sm:pb-0"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("h3", {
                      children: "Social Accounts",
                      className: "text-lg font-semibold leading-7 text-gray-900 sm:gap-4 sm:py-6"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm.make, {
                        member: member.fragmentRefs
                      }),
                      className: "pt-4 sm:pt-0"
                    })
                  ],
                  className: "pb-12 space-y-4 sm:space-y-0 divide-y divide-zinc-200 sm:pb-0"
                })
              ]
            }), hasFullProfile)
          ],
          className: "space-y-6"
        })
      ],
      className: "space-y-8 sm:space-y-0"
    }),
    className: "bg-white p-6 shadow-sm rounded space-y-8"
  });
}

let Page = {
  Fragment: Fragment$1,
  make: EditMarketingProfileMember$Page
};

let convertVariables = EditMarketingProfileMemberQuery_graphql.Internal.convertVariables;

let convertResponse = EditMarketingProfileMemberQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = EditMarketingProfileMemberQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables, EditMarketingProfileMemberQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, EditMarketingProfileMemberQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(EditMarketingProfileMemberQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(EditMarketingProfileMemberQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(EditMarketingProfileMemberQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(EditMarketingProfileMemberQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function EditMarketingProfileMember(props) {
  let match = use$2({
    memberId: props.memberId
  }, undefined, undefined, undefined);
  let result = match.marketingProfileMember;
  if (result.__typename === "MarketingProfileMember") {
    return JsxRuntime.jsx(EditMarketingProfileMember$Page, {
      member: result.fragmentRefs
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + result._0);
  }
}

let make = EditMarketingProfileMember;

exports.Header = Header;
exports.Page = Page;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
